<div
    class="container-fluid well"
    data-test-automation="road">
    <h5>{{title}}</h5>
    @if (isPrivateRoadQuestion()) {
        <div class="row">
            <div class="col-xs-4">
                <label class="control-label required-input">
                    Are any of the parent lots a private road or a private right of way to be acquired under Section 52 of the LAA?
                </label>
                <div class="input-group">
                    @for (option of laaAcquisitionValues; track option; let i = $index) {
                        <label class="nlr-radio">
                            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                <input
                                    type="radio"
                                    [ngClass]="{'has-radio-error':laaAcquisitionInput.invalid && laaAcquisitionInput.dirty}"
                                    name="laaAcquisition"
                                    #laaAcquisitionInput="ngModel"
                                    id="laaAcquisition{{i}}"
                                    [value]="option.value"
                                    [(ngModel)]="getModel().laaAcquisition"
                                    [disabled]="!option.active || readOnly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                    required
                                    data-test-automation="laa-acquisition-option-{{option.value}}" />
                            }
                            <span>{{option.displayValue}}</span>
                        </label>
                    }
                </div>
            </div>
        </div>
    }

    @if (isRoadClosureQuestion()) {
        <div class="row">
            <div class="col-xs-4">
                <label class="control-label required-input">Is there a road closure action on this plan?</label>
                <div class="input-group">
                    @for (option of roadClosureValues; track option; let i = $index) {
                        <label class="nlr-radio">
                            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                <input
                                    type="radio"
                                    [ngClass]="{'has-radio-error':roadClosureInput.invalid && roadClosureInput.dirty}"
                                    #roadClosureInput="ngModel"
                                    name="roadClosure"
                                    id="roadClosure{{i}}"
                                    [value]="option.value"
                                    [(ngModel)]="getModel().roadClosure"
                                    [disabled]="!option.active || readOnly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                    required
                                    data-test-automation="laa-acquisition-option-{{option.value}}" />
                            }
                            <span>{{option.displayValue}}</span>
                        </label>
                    }
                </div>
            </div>
        </div>
    }

    @if (isRoadWideningQuestion()) {
        <div class="row">
            <div class="col-xs-4">
                <label class="control-label required-input">Has a new road widening been created on the plan?</label>
                <div class="input-group">
                    @for (option1 of roadWideningValues; track option1; let i1 = $index) {
                        <label class="nlr-radio">
                            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                <input
                                    type="radio"
                                    [ngClass]="{'has-radio-error':roadWideningInput.invalid && roadWideningInput.dirty}"
                                    #roadWideningInput="ngModel"
                                    name="roadWidening"
                                    id="roadWidening{{i1}}"
                                    [value]="option1.value"
                                    [(ngModel)]="getModel().roadWidening"
                                    [disabled]="!option1.active || readOnly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                    required
                                    data-test-automation="road-widening-option-{{option1.value}}" />
                            }
                            <span>{{option1.displayValue}}</span>
                        </label>
                    }
                </div>
            </div>
            @if ((isDigitalPlan() || isPortalPlan()) && getModel().roadWidening) {
                <div class="col-xs-8">
                    <div class="row">
                        <div class="col-xs-5">
                            <label class="control-label">Plan label</label>
                            <div class="input-group">
                                <input
                                    type="text"
                                    id="roadWideningPlanLabel"
                                    class="form-control"
                                    name="roadWideningPlanLabel"
                                    [disabled]="true"
                                    theme="bootstrap"
                                    [value]="getRoadWideningPlanLabel()"
                                    title="The label printed on the plan graphic"
                                    data-test-automation="roadWideningPlanLabel" />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }

    @if (isRoadNameApprovalQuestion()) {
        <div class="row">
            <div class="col-xs-4">
                <label class="control-label required-input">Has a new road or road extension been created on the plan?</label>
                <div class="input-group">
                    @for (option of newOrExtendedRoadsValues; track option; let i = $index) {
                        <label class="nlr-radio">
                            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                <input
                                    type="radio"
                                    [name]="'newOrExtendedRoads'+i"
                                    [ngClass]="{'has-radio-error': newOrExtendedRoadsInput.invalid && newOrExtendedRoadsInput.dirty}"
                                    #newOrExtendedRoadsInput="ngModel"
                                    id="newOrExtendedRoads{{i}}"
                                    [value]="option.value"
                                    [(ngModel)]="getModel().newOrExtendedRoads"
                                    (ngModelChange)="newOrExtendedRoadsChange($event)"
                                    [disabled]="!option.active || readOnly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                    required
                                    data-test-automation="road-widening-option-{{option.value}}" />
                            }
                            <span>{{option.displayValue}}</span>
                        </label>
                    }
                </div>
            </div>
            @if (getModel().newOrExtendedRoads) {
                <div class="col-xs-8">
                    @for (road of getModel().roads; track road; let i = $index) {
                        <div
                            class="row row-actions"
                            data-test-automation="new-or-extended-road">
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-5">
                                        @if (i === 0) {
                                            <label
                                                class="control-label required-input"
                                                for="road{{i}}localityName">
                                                Locality
                                            </label>
                                        }
                                        @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                            <div
                                                data-test-automation="locality"
                                                title="Select the locality in which the road exists">
                                                <ng-select
                                                    class="nlr-ng-select"
                                                    [searchable]="false"
                                                    [clearable]="false"
                                                    [disabled]="readOnly || getLocalities().length === 0 || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                                    name="road{{i}}localityName"
                                                    id="road{{i}}localityName"
                                                    placeholder="Select"
                                                    [items]="getLocalities()"
                                                    [trackByFn]="localityTrackBy"
                                                    bindLabel="localityName"
                                                    [ngModel]="road.localityName"
                                                    (change)="localityChange(i, $event)"
                                                    required>
                                                </ng-select>
                                            </div>
                                        }
                                    </div>
                                    <div class="col-xs-5">
                                        @if (i === 0) {
                                            <label
                                                class="control-label required-input"
                                                for="road{{i}}name">
                                                Road name
                                            </label>
                                        }
                                        <div
                                            class="input-group"
                                            [ngClass]="{'has-error': roadInput.dirty &&!isValidRoadName(getModel().roads[i],i)}">
                                            <span class="input-group-addon">
                                                <i class="nlrp-icon nlrp-icon-edit"></i>
                                            </span>
                                            <input
                                                type="text"
                                                [id]="'roadname'+i"
                                                #roadInput="ngModel"
                                                [name]="'roadname'+i"
                                                class="form-control"
                                                placeholder="Search road"
                                                title="Search road name. If your road does not exist, please contact Landgate."
                                                autocomplete="off"
                                                [(ngModel)]="getModel().roads[i].road.displayName"
                                                (ngModelChange)="roadChanged(i)"
                                                (itemSelected)="roadSelected($event)"
                                                nlrFocus
                                                nlrFocusDelay="300"
                                                (focus)="onFocusRoadName(i)"
                                                (blur)="onBlurRoadName(getModel().roads[i],i)"
                                                [nlrTypehead]="roadsSearch"
                                                required />
                                            <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-search"></i></span>
                                        </div>
                                        @if (getModel().roads[i].road.displayName && roadInput.dirty &&!isValidRoadName(getModel().roads[i],i)) {
                                            <div class="help-block">
                                                <span>Error!</span>
                                                <span>No road name found.</span>
                                            </div>
                                        }
                                        @if (isRoadDuplicate(i)) {
                                            <div class="help-block">
                                                <span>Error!</span>
                                                @if (isRoadDuplicate(i)) {
                                                    <span>Road name / Plan label is not unique.</span>
                                                }
                                            </div>
                                        }
                                    </div>
                                    @if (!readOnly) {
                                        <div class="col-xs-2 actions actions-label-field">
                                            <i
                                                class="nlrp-icon nlrp-icon-add-circle"
                                                [ngClass]="{'first-road-btn-grp': i === 0}"
                                                (click)="addRow()"
                                                title="Select to add row to capture additional road/s"
                                                data-test-automation="add-road"></i>
                                            @if (i > 0 || getModel().roads.length > 1) {
                                                <i
                                                    class="nlrp-icon nlrp-icon-remove-circle"
                                                    (click)="removeRow(i)"
                                                    title="Select to delete the road"
                                                    data-test-automation="remove-road"></i>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    }
    @if (isLgaApprovedUnnamedRoadQuestion()) {
        <div class="row">
            <div class="col-xs-4">
                <label class="control-label required-input">Has a new LGA approved unnamed road or road extension been created on the plan?</label>
                <div class="input-group">
                    @for (option of lgaApprovedUnnamedValues; track option; let i = $index) {
                        <label class="nlr-radio">
                            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                <input
                                    type="radio"
                                    name="lgaApprovedUnnamedRoad"
                                    #lgaApprovedUnnamedRoadInput="ngModel"
                                    [ngClass]="{'has-radio-error': lgaApprovedUnnamedRoadInput.invalid && lgaApprovedUnnamedRoadInput.dirty}"
                                    id="lgaApprovedUnnamedRoad"
                                    [value]="option.value"
                                    [(ngModel)]="getModel().lgaApprovedUnnamedRoad"
                                    [disabled]="!option.active || readOnly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                    required
                                    data-test-automation="lga-approved-unnamed-road" />
                            }
                            <span>{{option.displayValue}}</span>
                        </label>
                    }
                </div>
            </div>
            <!--LGA approved unnamed road or road widening -->
            @if ((isDigitalPlan() || isPortalPlan()) && getModel().lgaApprovedUnnamedRoad) {
                <div class="col-xs-8">
                    <div class="row">
                        <div class="col-xs-5">
                            <label class="control-label">Plan label</label>
                            <div class="input-group">
                                <input
                                    type="text"
                                    id="lgaApprovedUnnamedRoadLabel"
                                    class="form-control"
                                    name="lgaApprovedUnnamedRoadLabel"
                                    theme="bootstrap"
                                    [value]="getLgaApprovedUnnamedRoadPlanLabel()"
                                    title="The label printed on the plan graphic"
                                    [disabled]="true"
                                    data-test-automation="lga-road-name" />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }

    @if (isRoadNameApprovalExemptQuestion()) {
        <div class="row">
            <div class="col-xs-4">
                <label class="control-label required-input">Has a new road been created that has a road name approval exemption?</label>
                <div class="input-group">
                    @for (option of approvalExemptionValues; track option; let i = $index) {
                        <label class="nlr-radio">
                            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                <input
                                    type="radio"
                                    name="approvalExemption"
                                    [id]="'approvalExemption'+i"
                                    #approvalExemptionInput="ngModel"
                                    [ngClass]="{'has-radio-error': approvalExemptionInput.invalid && approvalExemptionInput.dirty}"
                                    [value]="option.value"
                                    [(ngModel)]="getModel().approvalExemption"
                                    (ngModelChange)="approvalExemptionChange($event)"
                                    [disabled]="!option.active || readOnly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                    required
                                    data-test-automation="approval-exemption-option-{{option.value}}" />
                            }
                            <span>{{option.displayValue}}</span>
                        </label>
                    }
                </div>
            </div>
            <!--  Road Name Exemptions -->
            @if (['EDIT_INFORMATION', 'VIEW_INFORMATION']| hasPermissions) {
                <div>
                    @if (showExemptRoad()) {
                        <div class="col-xs-8">
                            <label class="control-label required-input">Plan label</label>
                            <div class="row">
                                @for (exemptedRoad of getModel().exemptedRoads; track exemptedRoad; let i = $index) {
                                    <div
                                        class="col-xs-5 road-name"
                                        data-test-automation="exempted-road">
                                        <label
                                            class="control-label"
                                            for="exemptedRoad{{i}}"
                                            style="display: none">
                                            Exempted Road Name
                                        </label>
                                        @if ((['EDIT_INFORMATION'] | hasPermissions)) {
                                            <div>
                                                <div
                                                    class="input-group"
                                                    [ngClass]="{'has-error':
                                                    (exemptedRoadInput.errors?.['required'] || exemptedRoadInput.invalid || oneSpaceCheck(i)) &&
                                                    (exemptedRoadInput.dirty || submitted) }">
                                                    <span class="input-group-addon"> <i class="nlrp-icon nlrp-icon-edit"></i></span>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        [id]="'exemptedRoad'+i"
                                                        [name]="'exemptedRoad'+i"
                                                        #exemptedRoadInput="ngModel"
                                                        [disabled]="readOnly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                                        min="0"
                                                        maxlength="500"
                                                        placeholder="ROAD"
                                                        [(ngModel)]="getModel().exemptedRoads[i].name"
                                                        (change)="exemptedRoadNameChanged()"
                                                        [nlrPattern]="validCharacters"
                                                        title="Enter or modify the road name"
                                                        nlrFocus
                                                        nlrFocusDelay="300"
                                                        required
                                                        nlrUppercase
                                                        data-test-automation="road-name" />
                                                    @if (!readOnly) {
                                                        <span class="input-group-addon">
                                                            <i
                                                                class="nlrp-icon nlrp-icon-add"
                                                                tabindex="0"
                                                                [ngClass]="{'disabled':readOnly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)}"
                                                                (click)="!readOnly && addExemptedRoadName()"
                                                                title="Add another road name"
                                                                data-test-automation="add-road-name"></i>
                                                        </span>
                                                    }
                                                    @if ((i > 0 || getModel().exemptedRoads?.length > 1) && !readOnly) {
                                                        <span class="input-group-addon">
                                                            <i
                                                                class="nlrp-icon nlrp-icon-remove"
                                                                tabindex="0"
                                                                [ngClass]="{'disabled':readOnly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)}"
                                                                (click)="!readOnly && removeExemptedRoadName(i)"
                                                                title="Remove the road name"
                                                                data-test-automation="remove-road-name"></i>
                                                        </span>
                                                    }
                                                </div>
                                                @if (
                                                    (exemptedRoadInput.errors?.['nlrPattern'] || oneSpaceCheck(i) ||
                                                     isExemptRoadDuplicate(getModel().exemptedRoads[i].name)) &&
                                                     (isRoadNamesModified || exemptedRoadInput.dirty || submitted)
                                                ) {
                                                    <div class="help-block">
                                                        <span>Error!</span>
                                                        @if (exemptedRoadInput.errors?.['nlrPattern']) {
                                                            <span>Road name must contain valid characters.</span>
                                                        }
                                                        @if (oneSpaceCheck(i)) {
                                                            <span>Only 1 space is permitted between entered road names.</span>
                                                        }
                                                        @if (isExemptRoadDuplicate(getModel().exemptedRoads[i].name)) {
                                                            <span>Road name / Plan label is not unique. </span>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
<!--<div class="help-block">-->
<!--    <span>Error!</span>-->
<!--    <span>{{groups.planInformation.invalidRoadText}}</span>-->
<!--</div>-->
